import {
    FeaturedArticleClassName,
    carouselClassName,
    carouselOverlayClassName,
    captionClassName,
    gridClassName,
    boxClassName,
    pxToRem,
    pxArrayToRem,
    archizeenTileClassName,
    tileImageClassName,
    tileImageSlotClassNames,
    SubheaderClassName,
    flexClassName,
    buttonClassName,
} from '@archipro-design/aria';

import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Wrap: StyleRule = () => ({
    position: `relative`,
    width: `100%`,
    userSelect: 'none',
});

export const Carousel: StyleRule = ({ theme }) => ({
    [`&.${carouselClassName}`]: {
        display: `block`,

        [`& img`]: {
            pointerEvents: 'none',
        },
        [`& .${carouselOverlayClassName}`]: {
            pointerEvents: `none`,
        },
        [`& .swiper`]: {
            [`& .swiper-pagination`]: {
                alignContent: 'end',
                justifyContent: `flex-start`,
                padding: pxArrayToRem([0, 18]),
                opacity: 1,
                textAlign: 'left',
                maxWidth: 'none',
                '--swiper-pagination-bullet-horizontal-gap': pxToRem(2),

                [`& .swiper-pagination-bullet`]: {
                    width: pxToRem(24),
                    height: pxToRem(2),
                    borderRadius: 0,
                    background: `#000`,
                    opacity: 0.3,
                    [`&:last-child`]: {
                        marginRight: 0,
                    },

                    [`&:first-child`]: {
                        marginLeft: 0,
                    },
                },
                [`& .swiper-pagination-bullet-active`]: {
                    opacity: 1,
                    height: pxToRem(2),
                },
            },
            [theme.screen.laptop]: {
                [`& .swiper-pagination`]: {
                    textAlign: 'right',
                    paddingRight: pxToRem(46),
                    top: pxToRem(825),
                    bottom: 'unset',
                    '--swiper-pagination-bullet-horizontal-gap': pxToRem(4),

                    [`& .swiper-pagination-bullet`]: {
                        width: pxToRem(48),
                    },
                },
            },

            [`& .swiper-slide:not(.swiper-slide-visible)`]: {
                [`& .${FeaturedArticleClassName}`]: {
                    [`& .${buttonClassName}`]: {
                        display: 'none',
                    },
                },
            },
        },
    },
});

export const PaddleWrap: StyleRule = () => ({
    position: 'absolute',
    right: pxToRem(30),
    bottom: pxToRem(151),

    [`& > *:first-child`]: {
        marginRight: pxToRem(8),
    },
});

export const SliderNavigation: StyleRule = () => ({
    position: 'absolute',
    width: '100%',
    height: pxToRem(880),
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const SliderNavButton: StyleRule = ({ theme }) => ({
    cursor: 'pointer',
    width: pxToRem(132),
    height: pxToRem(400),
    zIndex: theme.siteVariables.zIndexes.foreground,
    background: 'transparent',
    border: 'none',
    [`& .${svgIconClassName}`]: {
        width: pxToRem(32),
        height: pxToRem(24),
        fill: theme.siteVariables.colors.primitive.white,
    },
});

export const Tile: StyleRule = ({ theme }) => ({
    [`&.${FeaturedArticleClassName}`]: {
        width: '100%',

        [`& > div > div:not(:empty)`]: {
            borderStyle: `none`,
        },

        [`& > .${boxClassName}`]: {
            minWidth: '100%',
            width: '100%',
        },

        [`& .${gridClassName}`]: {
            paddingBottom: pxToRem(10),
        },

        [`& .${gridClassName} > * > .${captionClassName}`]: {
            lineHeight: theme.siteVariables.lineHeightSmaller,
        },
    },
});

export const MobileTile: StyleRule = ({ theme }) => ({
    [`&.${archizeenTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            height: pxToRem(263),
            margin: pxArrayToRem([0, 0, 16, 0]),
            borderRadius: 0,
            [`& > div`]: {
                height: pxToRem(263),
            },
        },
        [`& .${tileImageSlotClassNames.imageContainer}`]: {
            height: pxToRem(258),
        },

        '& .ui-tileOverlay': {
            display: 'none',
        },

        [`& > .${flexClassName}`]: {
            padding: pxArrayToRem([0, 18, 18]),
            [`& > .${flexClassName}`]: {
                [`& > .${flexClassName}`]: {
                    marginTop: pxToRem(3),
                    [`& > * .${captionClassName}`]: {
                        marginBottom: pxToRem(0),
                    },
                    [`& *`]: {
                        marginRight: pxToRem(2),
                    },
                },
            },
        },

        [`& .${SubheaderClassName}`]: {
            margin: pxArrayToRem([0, 0, 16, 0]),
            fontSize: pxToRem(28),
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            ...theme.siteVariables.textStyles.Article.Roman55,
        },
    },
});

export const CarouselForeground: StyleRule = () => ({
    [`& svg`]: {
        width: '100%',
        height: 'auto',
    },
});
